import * as sharedToken from './index';

export const cpds = {
  'accordion_body_style1_address_font_family_key': 'centraNo2',
  'accordion_body_style1_cta_font_family_key': 'centraNo2',
  'accordion_body_style1_description_font_family_key': 'centraNo2',
  'accordion_body_style1_number_font_family_key': 'centraNo2',
  'accordion_body_style1_title_font_family_key': 'PPEiko',
  'accordion_body_style2_description_font_family_key': 'centraNo2',
  'accordion_body_style2_image_description_font_family_key': 'centraNo2',
  'accordion_border_color': 'none',
  'accordion_destination_card_background_color': '#FFFFFF',
  'accordion_destination_card_border_color': '#E61E43',
  'accordion_destination_card_icon_color': '#E61E43',
  'accordion_label_font_family_key': 'centraNo2',
  'accordion_primary_text_color': '#0C0E1C',
  'accordion_secondary_text_color': '#676A7D',
  'accordion_title_long_font_family_key': 'PPEiko',
  'accordion_title_short_font_family_key': 'centraNo2',
  'ad_units_content_title_color': '#FFFFFF',
  'breadcrumb__crumb__arrow_color': sharedToken.color.common.cpds_neutral_0,
  'breadcrumb__crumb__font_line_height': '16px',
  'breadcrumb__crumb__font_size': '10px',
  'breadcrumb__crumb__font_weight': 'bold',
  'breadcrumb__crumb__hover_color': sharedToken.color.common.cpds_cream_400,
  'breadcrumb__link_crumb__default__text_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_description_primary_color': '#4D5167',
  'breaker_bio_description_secondary_color': '#4D5167',
  'breaker_bio_description_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_expand_icon_primary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_bio_expand_icon_secondary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_bio_expand_icon_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_primary_background_color': sharedToken.color.common.cpds_cream_100,
  'breaker_bio_secondary_background_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_subtitle_primary_color': sharedToken.color.common.cpds_neutral_500,
  'breaker_bio_subtitle_secondary_color': sharedToken.color.common.cpds_neutral_500,
  'breaker_bio_subtitle_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_tertiary_background_color': sharedToken.color.common.cpds_red_500,
  'breaker_bio_title_primary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_bio_title_secondary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_bio_title_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_bio_top_border_primary_color': sharedToken.color.common.cpds_cream_400,
  'breaker_bio_top_border_secondary_color': sharedToken.color.common.cpds_cream_400,
  'breaker_bio_top_border_tertiary_color': sharedToken.color.common.cpds_cream_400,
  'breaker_collage_2up_card_one_aspect_ratio': 'CPDS_3x4',
  'breaker_collage_2up_card_padding_top': '138.67px',
  'breaker_collage_2up_card_two_aspect_ratio': 'CPDS_1x1',
  'breaker_collage_3up_card_one_aspect_ratio': 'CPDS_1x1',
  'breaker_collage_3up_card_padding_top': '64px',
  'breaker_collage_3up_card_three_aspect_ratio': 'CPDS_1x1',
  'breaker_collage_3up_card_two_aspect_ratio': 'CPDS_3x4',
  'breaker_collage_card_title_primary_bullet_color': sharedToken.color.common.cpds_red_500,
  'breaker_collage_card_title_primary_color': sharedToken.color.common.cpds_neutral_500,
  'breaker_collage_card_title_secondary_bullet_color': sharedToken.color.common.cpds_red_500,
  'breaker_collage_card_title_secondary_color': sharedToken.color.common.cpds_neutral_500,
  'breaker_collage_card_title_tertiary_bullet_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_collage_card_title_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_collage_primary_background_color': sharedToken.color.common.cpds_cream_100,
  'breaker_collage_secondary_background_color': sharedToken.color.common.cpds_cream_100,
  'breaker_collage_tertiary_background_color': sharedToken.color.common.cpds_red_500,
  'breaker_quote_author_font_weight': '500',
  'breaker_quote_author_text_primary_color': '#4D5167',
  'breaker_quote_author_text_secondary_color': '#4D5167',
  'breaker_quote_author_text_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_quote_background_primary_color': sharedToken.color.common.cpds_cream_100,
  'breaker_quote_background_secondary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_quote_background_tertiary_color': sharedToken.color.common.cpds_red_500,
  'breaker_quote_job_title_primary_color': '#4D5167',
  'breaker_quote_job_title_secondary_color': '#4D5167',
  'breaker_quote_job_title_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'breaker_quote_mark_primary_color': sharedToken.color.common.cpds_red_500,
  'breaker_quote_mark_secondary_color': sharedToken.color.common.cpds_red_500,
  'breaker_quote_mark_tertiary_color': sharedToken.color.common.cpds_cream_100,
  'breaker_quote_title_text_primary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_quote_title_text_secondary_color': sharedToken.color.common.cpds_neutral_900,
  'breaker_quote_title_text_tertiary_color': sharedToken.color.common.cpds_neutral_0,
  'button_floating_background_active_color': '#E0E0E0',
  'button_floating_background_color': 'unset',
  'button_floating_background_disabled_color': 'unset',
  'button_floating_background_hover_color': '#F2F2F2',
  'button_floating_border_color': '#10101014',
  'button_floating_font_size': '16px',
  'button_floating_font_weight': '500',
  'button_floating_height': '36px',
  'button_floating_text_active_color': '#858585',
  'button_floating_text_color': '#858585',
  'button_floating_text_disabled_color': '#858585',
  'button_floating_text_hover_color': '#858585',
  'button_large_font_size': '16px',
  'button_large_max_height': '48px',
  'button_large_max_width': '48px',
  'button_large_padding': '0px 16px',
  'button_link_border_color': sharedToken.color.common.cpds_neutral_300,
  'button_link_font_size': '12px',
  'button_link_font_weight': '500',
  'button_link_text_color': sharedToken.color.common.cpds_neutral_900,
  'button_link_text_disabled_color': sharedToken.color.common.cpds_neutral_400,
  'button_medium_font_size': '16px',
  'button_medium_max_height': '36px',
  'button_medium_max_width': '36px',
  'button_medium_padding': '0px 16px',
  'button_primary_background_color': '#1668E3',
  'button_primary_background_disabled_color': '#1668E3',
  'button_primary_background_hover_color': '#0D4EAF',
  'button_primary_focus_background_color': '#0E3672',
  'button_primary_focus_border_color': '',
  'button_primary_focus_text_color': '#FFFFFF',
  'button_primary_font_size': '12px',
  'button_primary_font_weight': '500',
  'button_primary_text_color': '#FFFFFF',
  'button_primary_text_disabled_color': '#FFFFFF',
  'button_primary_text_hover_color': '#FFFFFF',
  'button_secondary_background_color': '#FFFFFF',
  'button_secondary_background_disabled_color': '#FFFFFF',
  'button_secondary_background_hover_color': '#F3F3F5',
  'button_secondary_border_color': '#818494',
  'button_secondary_disabled_border_color': '#E2E4EC',
  'button_secondary_focus_background_color': '#DFE0E4',
  'button_secondary_focus_border_color': '#818494',
  'button_secondary_focus_text_color': '#191E3B',
  'button_secondary_font_size': '12px',
  'button_secondary_font_weight': '700',
  'button_secondary_text_color': '#191E3B',
  'button_secondary_text_disabled_color': '#191E3B',
  'button_secondary_text_hover_color': '#191E3B',
  'button_small_font_size': '12px',
  'button_small_max_height': '32px',
  'button_small_max_width': '32px',
  'button_small_padding': '0px 12px',
  'button_tertiary_background_active_color': 'unset',
  'button_tertiary_background_color': 'unset',
  'button_tertiary_background_disabled_color': 'unset',
  'button_tertiary_background_hover_color': 'unset',
  'button_tertiary_focus_border_color': 'unset',
  'button_tertiary_focus_text_underline_color': 'unset',
  'button_tertiary_font_size': '12px',
  'button_tertiary_font_weight': '700',
  'button_tertiary_text_active_color': '#4D5167',
  'button_tertiary_text_color': '#191E3B',
  'button_tertiary_text_disabled_color': '#191E3B',
  'button_tertiary_text_hover_color': '#676A7D',
  'caption_background_color': sharedToken.color.common.cpds_red_500,
  'caption_font_color': sharedToken.color.common.cpds_neutral_0,
  'caption_icon_color': sharedToken.color.common.cpds_neutral_0,
  'card_backgroun_color': '#000',
  'card_cta_action_border_left_color': sharedToken.color.common.cpds_cream_400,
  'card_dark_background_color': sharedToken.color.common.cpds_cream_100,
  'card_image_border_radius': '8px',
  'card_image_horizontal_varition_mobile_width': '358px',
  'card_image_horizontal_varition_width': '774px',
  'card_left_border_color': sharedToken.color.common.cpds_red_500,
  'card_light_background_color': sharedToken.color.common.cpds_neutral_0,
  'card_overlay_gradient_color': sharedToken.color.common.cpds_neutral_900,
  'cpds_transpoter_background_color_primary': '#FBF8F1',
  'cpds_transpoter_background_color_secondary': '#FFFFFF',
  'cpds_transpoter_border_color_primary': '#EBE4D5',
  'cpds_transpoter_border_color_secondary': '#E2E4EC',
  'cpds_transpoter_font_color_primary': '#0C0E1C',
  'datepicker_bg_color_mobile': sharedToken.color.common.cpds_cream_100,
  'datepicker_close_btn_border_color_mobile': sharedToken.color.common.cpds_cream_400,
  'datepicker_close_btn_icon_color_mobile': sharedToken.color.common.cpds_neutral_900,
  'datepicker_option_item_color': sharedToken.color.common.cpds_neutral_900,
  'datepicker_option_item_selected_color': sharedToken.color.common.cpds_red_100,
  'datepicker_select_color': sharedToken.color.common.cpds_red_500,
  'datepicker_seperator_color_mobile': sharedToken.color.common.cpds_cream_400,
  'datepicker_trailling_icon_color': sharedToken.color.common.cpds_red_500,
  'dot_active_color': 'red',
  'dot_default_color': 'black',
  'drop_down_applied_border_color': sharedToken.color.common.cpds_red_500,
  'drop_down_applied_color': 'red',
  'drop_down_applied_font_weight': '500',
  'drop_down_bg_color_mobile': sharedToken.color.common.cpds_cream_100,
  'drop_down_close_btn_border_color_mobile': sharedToken.color.common.cpds_cream_400,
  'drop_down_close_btn_icon_color_mobile': sharedToken.color.common.cpds_neutral_900,
  'drop_down_closed_color': 'green',
  'drop_down_color': '#000',
  'drop_down_disabled_color': 'red',
  'drop_down_item_background_color': 'black',
  'drop_down_item_color': 'red',
  'drop_down_item_height': '40px',
  'drop_down_item_hover_background_color': 'red',
  'drop_down_item_img_width': '40px',
  'drop_down_item_padding': '12px',
  'drop_down_open_color': 'red',
  'drop_down_option_item_selected_color': sharedToken.color.common.cpds_red_100,
  'drop_down_primary_color': 'blue',
  'drop_down_primary_hover_color': 'blue',
  'drop_down_wrapper_min_width': '250px',
  'drop_down_wrapper_padding': '4px',
  'editorial_one_up_primary_arrow_color': '#E61E43',
  'editorial_one_up_primary_arrow_text_color': '#FFFFFF',
  'editorial_one_up_primary_background_color': '#FBF8F1',
  'editorial_one_up_primary_dot_active_color': '#0C0E1C',
  'editorial_one_up_primary_dot_color': '#9CA0B0',
  'editorial_one_up_secondary_arrow_color': '#E61E43',
  'editorial_one_up_secondary_arrow_text_color': '#FFFFFF',
  'editorial_one_up_secondary_background_color': '#FFFFFF',
  'editorial_one_up_secondary_dot_active_color': '#0C0E1C',
  'editorial_one_up_secondary_dot_color': '#9CA0B0',
  'editorial_one_up_tertiary_arrow_color': '#FFFFFF',
  'editorial_one_up_tertiary_arrow_text_color': '#0C0E1C',
  'editorial_one_up_tertiary_background_color': '#E61E43',
  'editorial_one_up_tertiary_dot_active_color': '#FFFFFF',
  'editorial_one_up_tertiary_dot_color': '#F37A8A',
  'elevation_level_eight_color': '#000B26',
  'elevation_level_eight_opacity': '0.24',
  'elevation_level_four_color': '#000B26',
  'elevation_level_four_opacity': '0.2',
  'elevation_level_one_color': '#000B26',
  'elevation_level_one_opacity': '0.12',
  'elevation_level_six_color': '#000B26',
  'elevation_level_six_opacity': '0.22',
  'elevation_level_sixteen_color': '#000B26',
  'elevation_level_sixteen_opacity': '0.24',
  'elevation_level_twenty_four_color': '#000B26',
  'elevation_level_twenty_four_opacity': '0.3',
  'elevation_level_two_color': '#000B26',
  'elevation_level_two_opacity': '0.2',
  'horizontally_tabbed_primary_background_color': '#FBF8F1',
  'horizontally_tabbed_primary_eyebrow_color': '#676A7D',
  'horizontally_tabbed_primary_tab_active_border_color': '#E61E43',
  'horizontally_tabbed_primary_tab_border_color': '#D1D5E2',
  'horizontally_tabbed_primary_tab_color': '#0C0E1C',
  'horizontally_tabbed_primary_title_color': '#0C0E1C',
  'horizontally_tabbed_secondary_background_color': '#FFFFFF',
  'horizontally_tabbed_secondary_eyebrow_color': '#676A7D',
  'horizontally_tabbed_secondary_tab_active_border_color': '#E61E43',
  'horizontally_tabbed_secondary_tab_border_color': '#D1D5E2',
  'horizontally_tabbed_secondary_tab_color': '#0C0E1C',
  'horizontally_tabbed_secondary_title_color': '#0C0E1C',
  'horizontally_tabbed_tertiary_background_color': '#E61E43',
  'horizontally_tabbed_tertiary_eyebrow_color': '#FFFFFF',
  'horizontally_tabbed_tertiary_tab_active_border_color': '#FFFFFF',
  'horizontally_tabbed_tertiary_tab_border_color': '#D1D5E2',
  'horizontally_tabbed_tertiary_tab_color': '#FFFFFF',
  'horizontally_tabbed_tertiary_title_color': '#FFFFFF',
  'hotel_deals_subtitle_color': '#676A7D',
  'inline_image_primary_text_color': '#0C0E1C',
  'inline_pull_quote_author_font_weight': '500',
  'inline_pull_quote_author_text_primary_color': '#4D5167',
  'inline_pull_quote_background_primary_color': '#FBF8F1',
  'inline_pull_quote_background_secondary_color': '#FFFFFF',
  'inline_pull_quote_background_tertiary_color': '#E61E43',
  'inline_pull_quote_title_text_primary_color': '#0C0E1C',
  'inline_pull_quote_title_text_tertiary_color': '#FFFFFF',
  'input_fields_border_color': sharedToken.color.common.cpds_neutral_300,
  'input_fields_border_radius': '40px',
  'input_fields_disable_border_color': '#D1D5E2',
  'input_fields_disable_font_color': '#676A7D',
  'input_fields_disable_font_size': '14px',
  'input_fields_disable_font_weight': '400',
  'input_fields_disable_submit_cta_color': '#9CA0B0',
  'input_fields_disable_submit_cta_font_size': '14px',
  'input_fields_disable_submit_cta_font_weight': '700',
  'input_fields_error_border_color': '#C01E1E',
  'input_fields_error_label_color': '#C01E1E',
  'input_fields_font_color': '#191E3B',
  'input_fields_font_size': '12px',
  'input_fields_font_weight': '400',
  'input_fields_helper_icon_disable_color': '#676A7D',
  'input_fields_helper_label_color': '#0C0E1C',
  'input_fields_helper_label_disable_font_color': '#676A7D',
  'input_fields_helper_label_disable_font_size': '14px',
  'input_fields_helper_label_disable_font_weight': '700',
  'input_fields_helper_label_disable_line_height': '30px',
  'input_fields_helper_label_font_size': '14px',
  'input_fields_helper_label_font_weight': '700',
  'input_fields_helper_label_line_height': '20px',
  'input_fields_label_color': sharedToken.color.common.cpds_neutral_900,
  'input_fields_label_disable_color': '#676A7D',
  'input_fields_label_disable_font_size': '14px',
  'input_fields_label_disable_font_weight': '500',
  'input_fields_label_disable_icon_color': '#676A7D',
  'input_fields_label_disable_line_height': '30px',
  'input_fields_label_font_size': '14px',
  'input_fields_label_font_weight': '500',
  'input_fields_label_icon_color': '#31374F',
  'input_fields_label_line_height': '20px',
  'input_fields_placeholder_font_color': '#818494',
  'input_fields_placeholder_font_size': '12px',
  'input_fields_placeholder_font_weight': '400',
  'input_fields_submit_cta_color': '#9CA0B0',
  'input_fields_submit_cta_focus_color': '#0C0E1C',
  'input_fields_submit_cta_font_size': '14px',
  'input_fields_submit_cta_font_weight': '700',
  'magazine_nameplate_partnership_primary_color': '#FBF8F1',
  'magazine_nameplate_partnership_primary_content_color': '#4D5167',
  'magazine_nameplate_partnership_primary_heading_color': '#0C0E1C',
  'magazine_nameplate_partnership_secondary_color': '#FFFFFF',
  'magazine_nameplate_partnership_secondary_content_color': '#4D5167',
  'magazine_nameplate_partnership_secondary_heading_color': '#0C0E1C',
  'magazine_nameplate_partnership_tertiary_color': '#E61E43',
  'magazine_nameplate_partnership_tertiary_content_color': '#FFFFFF',
  'magazine_nameplate_partnership_tertiary_heading_color': '#FFFFFF',
  'magazine_nameplate_standard_primary_color': '#FBF8F1',
  'magazine_nameplate_standard_primary_content_color': '#4D5167',
  'magazine_nameplate_standard_primary_heading_color': '#0C0E1C',
  'magazine_nameplate_standard_secondary_color': '#FFFFFF',
  'magazine_nameplate_standard_secondary_content_color': '#4D5167',
  'magazine_nameplate_standard_secondary_heading_color': '#0C0E1C',
  'magazine_nameplate_standard_tertiary_color': '#E61E43',
  'magazine_nameplate_standard_tertiary_content_color': '#FFFFFF',
  'magazine_nameplate_standard_tertiary_heading_color': '#FFFFFF',
  'module_3up_cards_primary_background_color': '#FBF8F1',
  'module_3up_cards_secondary_background_color': '#FFFFFF',
  'module_3up_pill_label_color': sharedToken.color.cpds_primary,
  'module_breaker_competition_background_color': '#FBF8F1',
  'module_breaker_competition_primary_text_color': '#0C0E1C',
  'module_breaker_competition_secondary_background_color': '#FFFFFF',
  'module_breaker_competition_secondary_text_color': '#0C0E1C',
  'module_breaker_competition_tertiary_background_color': '#E61E43',
  'module_breaker_competition_tertiary_error_color': '#000000',
  'module_breaker_competition_tertiary_text_color': '#FFFFFF',
  'module_category_landing_hero_background_color': '#FBF8F1',
  'module_category_landing_hero_content_direction': 'row-reverse',
  'module_category_landing_hero_secondary_background_color': '#FBF8F1',
  'module_category_landing_hero_tertiary_background_color': '#FBF8F1',
  'module_categroy_landing_hero_paragraph_primary_color': '#4D5167',
  'module_categroy_landing_hero_paragraph_secondary_color': '#4D5167',
  'module_categroy_landing_hero_paragraph_tertiary_color': '#FFF',
  'module_categroy_landing_hero_title_primary_color': '#0C0E1C',
  'module_categroy_landing_hero_title_secondary_color': '#0C0E1C',
  'module_categroy_landing_hero_title_tertiary_color': '#FFF',
  'module_event_card_secondary_button_border_color': '#F37A8A',
  'module_highlight_3up_primary_background_color': '#FBF8F1',
  'module_highlight_3up_secondary_background_color': '#FFFFFF',
  'module_inline_image_background_color': '#FFFFFF',
  'module_inline_image_secondary_background_color': '#FFFFFF',
  'module_richtext_background_color': '#FBF8FF',
  'module_richtext_secondary_background_color': '#FFFFFF',
  'module_richtext_tertiary_background_color': '#FFFFFF',
  'module_seo_footer_link_color': '#191E3B',
  'module_seo_footer_primary_background_color': '#FBF8F1',
  'module_seo_footer_secondary_background_color': '#FBF8F1',
  'module_seo_footer_separator_color': '#EBE4D5',
  'module_seo_footer_sub_title_color': '#191E3B',
  'module_seo_footer_tertiary_background_color': '#FBF8F1',
  'module_seo_footer_title_color': '#191E3B',
  'module_v3_4up_background_primary_color': '#FBF8F1',
  'module_v3_4up_background_secondary_color': '#FFFFFF',
  'module_v3_4up_carousel_background_primary_color': '#FBF8F1',
  'module_v3_4up_carousel_background_secondary_color': '#FFFFFF',
  'module_v3_4up_carousel_dots_active_color': '#0C0E1C',
  'module_v3_4up_carousel_image_border_radius': '8px',
  'module_v3_4up_carousel_image_card_top_padding': '80px',
  'module_v3_4up_carousel_image_card_top_padding_mobile': '40px',
  'module_v3_4up_carousel_image_tag_font_color': '#4D5167',
  'module_v3_4up_carousel_tag_border_color': '#F37A8A',
  'module_v3_4up_carousel_title_primary_color': '#0C0E1C',
  'module_v3_area_tabbed_list_font_color': '#0C0E1C',
  'module_v3_area_tabbed_list_location_icon_border_color': ' #E61E43',
  'module_v3_area_tabbed_list_location_icon_color': '#E61E43',
  'module_v3_area_tabbed_list_map_center_pin_color': '#FFFFFF',
  'module_v3_area_tabbed_list_map_pin_border_color': '#EBE4D5',
  'module_v3_area_tabbed_list_map_pin_color': '#E61E43',
  'module_v3_area_tabbed_list_map_pin_text_color': '#FFFFFF',
  'module_v3_area_tabbed_list_navigation_arrow_color': '#ED4C67',
  'module_v3_area_tabbed_list_navigation_arrow_prev_color': '#F37A8A',
  'module_v3_area_tabbed_list_nearby_primary_color': '#FFFFFF',
  'module_v3_area_tabbed_list_nearby_secondary_color': '#FFFFFF',
  'module_v3_area_tabbed_list_nearby_tertiary_color': '#FFFFFF',
  'module_v3_area_tabbed_list_primary_color': '#FBF8F1',
  'module_v3_area_tabbed_list_scrollbar_color': '#EBE4D5',
  'module_v3_area_tabbed_list_scrollbar_thumb_color': '#0C0E1C',
  'module_v3_area_tabbed_list_secondary_color': '#FFFFFF',
  'module_v3_area_tabbed_list_tab_highlight_color': '#E61E43',
  'module_v3_area_tabbed_list_tab_underline_primary_color': '#EBE4D5',
  'module_v3_area_tabbed_list_tab_underline_secondary_color': '#EBE4D5',
  'module_v3_area_tabbed_list_tab_underline_tertiary_color': '#EBE4D5',
  'module_v3_area_tabbed_list_tertiary_color': '#E61E43',
  'module_v3_area_tabbed_list_tertiary_font_color': '#FFFFFF',
  'module_v3_area_tabbed_list_tertiary_tab_highlight_color': '#FFFFFF',
  'module_v3_basic_oneup_module_font_color': '#4D5167',
  'module_v3_basic_oneup_module_image_border_radius': '8px',
  'module_v3_basic_oneup_module_mobile_padding': '16px',
  'module_v3_basic_oneup_module_primary_color': '#FBF8F1',
  'module_v3_basic_oneup_module_secondary_color': '#FFFFFF',
  'module_v3_basic_oneup_module_tag_border_color': '#F37A8A',
  'module_v3_basic_oneup_module_tertiary_color': '#E61E43',
  'module_v3_basic_oneup_module_tertiary_font_color': '#FFFFFF',
  'module_v3_basic_oneup_module_tertiary_title_color': '#FFFFFF',
  'module_v3_basic_oneup_module_title_color': '#0C0E1C',
  'module_v3_breaker_video_control_border_color': '#FFFFFF',
  'module_v3_breaker_video_primary_background_color': '#FBF8F1',
  'module_v3_breaker_video_primary_text_active_color': '#4D5167',
  'module_v3_breaker_video_primary_text_color': '#0C0E1C',
  'module_v3_breaker_video_primary_transcript_color': '#676A7D',
  'module_v3_breaker_video_secondary_background_color': '#FFFFFF',
  'module_v3_breaker_video_secondary_text_active_color': '#4D5167',
  'module_v3_breaker_video_secondary_text_color': '#0C0E1C',
  'module_v3_breaker_video_secondary_transcript_color': '#676A7D',
  'module_v3_breaker_video_tertiary_background_color': '#E61E43',
  'module_v3_breaker_video_tertiary_text_active_color': '#b3b3b3',
  'module_v3_breaker_video_tertiary_text_color': '#FFFFFF',
  'module_v3_breaker_video_tertiary_transcript_color': '#E6E6E6',
  'module_v3_breaker_video_video_border_radius': '8px',
  'module_v3_card_fixture_product_action_border_left_color': '#E2E4EC',
  'module_v3_card_fixture_product_action_cta_text_color': '#0C0E1C',
  'module_v3_card_fixture_product_background_color': '#FFFFFF',
  'module_v3_card_fixture_product_calandar_icon_color': '#E61E43',
  'module_v3_card_fixture_product_price_color': '#0C0E1C',
  'module_v3_card_fixture_product_title_text_color': '#0C0E1C',
  'module_v3_cover_package_background_color': '#FBF8F1',
  'module_v3_cover_package_image_border_radius': '8px',
  'module_v3_cover_package_story_separator_color': '#EBE4D5',
  'module_v3_cover_package_tag_font_color': '#4D5167',
  'module_v3_cover_package_tag_underline_color': '#F37A8A',
  'module_v3_cover_package_title_font_color': '#0C0E1C',
  'module_v3_fixture_planner_filter_background_primary_color': sharedToken.color.common.cpds_cream_100,
  'module_v3_fixture_planner_filter_background_secondary_color': '#FFFFFF',
  'module_v3_fixture_planner_filter_background_tertiary_color': sharedToken.color.common.cpds_red_500,
  'module_v3_fixture_planner_filter_item_hover_color': '#FFE4E5',
  'module_v3_fixture_planner_filter_text_primary_color': '#0C0E1C',
  'module_v3_fixture_planner_filter_text_secondary_color': '#0C0E1C',
  'module_v3_fixture_planner_filter_text_tertiary_color': '#FFFFFF',
  'module_v3_fixture_planner_option_1_result_list_background_color': '#FFFFFF',
  'module_v3_fixture_planner_option_2_result_list_background_color': sharedToken.color.common.cpds_cream_100,
  'module_v3_fixture_planner_result_background_color': '#FFFFFF',
  'module_v3_fixture_planner_result_icon_color': sharedToken.color.common.cpds_red_500,
  'module_v3_global_navigation_font_color': '#FFFFFF',
  'module_v3_global_navigation_menu_background_color': '#FBF8F1',
  'module_v3_global_navigation_menu_item_arrow_color': '#E61E43',
  'module_v3_global_navigation_menu_item_border_color': '#E2E4EC',
  'module_v3_global_navigation_menu_item_hover_color': '#FFE4E5',
  'module_v3_global_navigation_menu_items_font_color': '#0C0E1C',
  'module_v3_global_navigation_primary_color': '#E61E43',
  'module_v3_global_navigation_scroll_thumb_color': '#0C0E1C',
  'module_v3_global_navigation_scroll_track_color': '#D1D5E2',
  'module_v3_global_search_wizard_brand_color': '#E61E43',
  'module_v3_global_search_wizard_date_range_color': '#FFE4E5',
  'module_v3_global_search_wizard_primary_button_hover_color': '#C01E1E',
  'module_v3_shoppable_one_carousel_background_primary_color': '#FBF8F1',
  'module_v3_shoppable_one_carousel_background_secondary_color': '#FFFFFF',
  'module_v3_shoppable_one_carousel_background_tertiary_color': '#E61E43',
  'module_v3_shoppable_one_carousel_description_color': '#4D5167',
  'module_v3_shoppable_one_carousel_icon_color': '#E61E43',
  'module_v3_shoppable_one_carousel_image_border_radius': '8px',
  'module_v3_shoppable_one_carousel_price_border_color': '#EBE4D5',
  'module_v3_shoppable_one_carousel_tertiary_arrow_color': '#FFFFFF',
  'module_v3_shoppable_one_carousel_tertiary_dots_inactive_color': '#F37A8A',
  'module_v3_shoppable_one_carousel_tertiary_rating_background_color': '#B8E6C3',
  'module_v3_shoppable_one_carousel_tertiary_rating_text_color': '#175F29',
  'module_v3_shoppable_one_carousel_tertiary_text_color': '#FFFFFF',
  'module_v3_shoppable_one_carousel_title_color': '#0C0E1C',
  'module_v3_six_up_card_grid_primary_background_color': '#FBF8F1',
  'module_v3_six_up_card_grid_secondary_background_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_dark_background_video_icon_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_full_bleed_font_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_light_background_video_icon_color': '#E61E43',
  'module_v3_sponsored_content_hero_primary_color': '#FBF8F1',
  'module_v3_sponsored_content_hero_secondary_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_tertiary_color': '#E61E43',
  'module_v3_sponsored_content_hero_tertiary_sub_text_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_tertiary_tag_underlinecolor': '#EBE4D5',
  'module_v3_sponsored_content_hero_tertiary_title_text_color': '#FFFFFF',
  'module_v3_sponsored_content_hero_top_image_sub_text_font_color': '#4D5167',
  'module_v3_sponsored_content_hero_top_image_title_text_font_color': '#0C0E1C',
  'new_token_genrate': 'sfsdf',
  'product_card_fixture_mobile_width': '358px',
  'product_card_fixture_width': '351px',
  'progress_bar_background_color': 'black',
  'progress_bar_seeker_color': 'red',
  'ratings_green_background_color': sharedToken.color.common.cpds_green_200,
  'ratings_green_background_rating_score_text_color': sharedToken.color.common.cpds_green_700,
  'ratings_green_background_text_color': sharedToken.color.common.cpds_neutral_900,
  'ratings_grey_background_color': sharedToken.color.common.cpds_neutral_200,
  'ratings_grey_background_rating_score_text_color': sharedToken.color.common.cpds_neutral_900,
  'ratings_grey_background_text_color': sharedToken.color.common.cpds_neutral_900,
  'richtext_underline_link_hover_color': '#E61E43',
  'scrollbar_thumb_color': 'red',
  'scrollbar_track_color': 'black',
  'section_title_background_color': sharedToken.color.common.cpds_red_500,
  'section_title_color': sharedToken.color.common.cpds_neutral_0,
  'section_title_description_color': sharedToken.color.common.cpds_neutral_0,
  'section_title_description_font_size': '16px',
  'section_title_description_font_weight': '400',
  'section_title_description_line_height': '24px',
  'section_title_description_text_align': 'left',
  'section_title_eyebrow_color': sharedToken.color.common.cpds_neutral_0,
  'section_title_eyebrow_font_size': '16px',
  'section_title_eyebrow_font_weight': '400',
  'section_title_eyebrow_line_height': '24px',
  'section_title_eyebrow_text_align': 'left',
  'section_title_font_size': '40px',
  'section_title_font_weight': '250',
  'section_title_line_height': '44px',
  'section_title_text_align': 'left',
  'separator_border_width': '0px',
  'separator_height': '0px',
  'separator_position_left': '0%',
  'separator_position_top': '0',
  'separator_primary_background_color': 'black',
  'separator_primary_color': 'black',
  'separator_width': '100%',
  'sponsor_tag_brand_logo_max_height': '24px',
  'sponsor_tag_brand_logo_max_width': '20px',
  'sponsor_tag_brand_logo_width': '20px',
  'sponsor_tag_color': sharedToken.color.common.cpds_neutral_0,
  'subtitle_paragraph_author_color': sharedToken.color.common.cpds_neutral_600,
  'subtitle_paragraph_background_color': sharedToken.color.common.cpds_neutral_0,
  'subtitle_paragraph_content_color': sharedToken.color.common.cpds_neutral_600,
  'subtitle_paragraph_date_color': sharedToken.color.common.cpds_neutral_500,
  'subtitle_paragraph_separator_border_color': sharedToken.color.common.cpds_cream_400,
  'subtitle_paragraph_tag_border_color': sharedToken.color.common.cpds_red_300,
  'subtitle_paragraph_tag_color': sharedToken.color.common.cpds_neutral_600,
  'subtitle_paragraph_title_color': sharedToken.color.common.cpds_neutral_900,
  'tab_nav_item_color': sharedToken.color.common.cpds_neutral_800,
  'tab_nav_item_default_opacity': '1',
  'tab_nav_item_highlighter_color': sharedToken.color.common.cpds_accent_600,
  'tab_nav_item_selected_color': sharedToken.color.common.cpds_accent_600,
  'tab_nav_item_selected_opacity': '1',
  'tabs_container_border_bottom_color': sharedToken.color.common.cpds_neutral_200,
  'tabs_container_min_block_size': '48px',
  'tag_background_color': 'transparent',
  'tag_border': `1px solid ${sharedToken.color.common.cpds_cream_400}`,
  'tag_border_radius': '34px',
  'tag_color': sharedToken.color.common.cpds_neutral_0,
  'tag_disabled_background_color': 'transparent',
  'tag_disabled_border': `1px solid ${sharedToken.color.common.cpds_red_300}`,
  'tag_disabled_color': sharedToken.color.common.cpds_red_300,
  'tag_filter_applied_background': sharedToken.color.common.cpds_neutral_0,
  'tag_filter_applied_border': `1px solid ${sharedToken.color.common.cpds_neutral_0}`,
  'tag_filter_applied_color': sharedToken.color.common.cpds_neutral_900,
  'tag_height': '24px',
  'tag_hover_background_color': 'transparent',
  'tag_hover_border': `1px solid ${sharedToken.color.common.cpds_neutral_0}`,
  'tag_hover_color': sharedToken.color.common.cpds_neutral_0,
  'tag_min_width': '44px',
  'tag_unclickable_background_color': 'transparent',
  'tag_unclickable_border': `1px solid transparent`,
  'tag_unclickable_color': sharedToken.color.common.cpds_neutral_0,
  'testimonial_arrow_color': '#0C0E1C',
  'testimonial_auther_color': '#FFFFFF',
  'testimonial_carousel_dark_gray': '#FFFFFF',
  'testimonial_carousel_gray': '#31374F',
  'testimonial_carousel_light_gray': '#FFFFFF',
  'three_up_card_background_color': '#FFFFFF',
  'travel_hub_hero_desktop_height': '680px',
  'travel_hub_hero_headline_color': sharedToken.color.common.cpds_neutral_100,
  'travel_hub_hero_max_content_width': '1248px',
  'travel_hub_hero_mobile_height': '510px',
  'travel_hub_hero_overlay_color': '#000000',
  'travel_hub_hero_overlay_opacity': 0,
  'travel_hub_hero_scroll_down_arrow_color': sharedToken.color.common.cpds_neutral_100,
  'travel_hub_hero_sub_headline_color': sharedToken.color.common.cpds_neutral_100,
  'travel_hub_hero_video_control_color': sharedToken.color.common.cpds_neutral_100,
  'v3_ad_units_background': '#F5F5F5',
  'v3_ad_units_header_title_color': '#676A7D',
  'v3_article_hero_description_color': sharedToken.color.common.cpds_neutral_600,
  'v3_article_hero_headline_color': sharedToken.color.common.cpds_neutral_900,
  'v3_article_hero_image_border_radius': '8px',
  'v3_article_hero_image_panel_padding': '16px',
  'v3_article_hero_onekey_primary_bg_color': sharedToken.color.common.cpds_orange_300,
  'v3_article_hero_onekey_primary_text_color': 'dark',
  'v3_article_hero_onekey_secondary_bg_color': sharedToken.color.common.cpds_red_200,
  'v3_article_hero_onekey_secondary_text_color': 'dark',
  'v3_article_hero_primary_bg_color': sharedToken.color.common.cpds_cream_100,
  'v3_article_hero_primary_text_color': 'dark',
  'v3_article_hero_secondary_bg_color': sharedToken.color.common.cpds_neutral_0,
  'v3_article_hero_secondary_text_color': 'dark',
  'v3_article_hero_sub_text_color': sharedToken.color.common.cpds_neutral_500,
  'v3_article_hero_tertiary_bg_color': sharedToken.color.common.cpds_red_500,
  'v3_article_hero_tertiary_text_color': 'light',
  'v3_article_hero_top_image_variation_height': '824px',
  'v3_article_hero_video_icon_color': sharedToken.color.common.cpds_neutral_0,
  'v3_breaker_app_download_image_border_radius': '8px',
  'v3_breaker_app_download_primary_background_color': sharedToken.color.common.cpds_cream_100,
  'v3_breaker_app_download_primary_content_color': sharedToken.color.common.cpds_neutral_900,
  'v3_breaker_app_download_secondary_background_color': sharedToken.color.common.cpds_neutral_0,
  'v3_breaker_app_download_secondary_content_color': sharedToken.color.common.cpds_neutral_900,
  'v3_breaker_app_download_tertiary_background_color': sharedToken.color.common.cpds_red_500,
  'v3_breaker_app_download_tertiary_content_color': sharedToken.color.common.cpds_neutral_0,
  'v3_breaker_gallery_image_border_radius': '8px',
  'v3_breaker_gallery_primary_background_color': '#FBF8F1',
  'v3_breaker_gallery_primary_body_copy_color': '#676A7D',
  'v3_breaker_gallery_primary_body_copy_icon_color': '#E61E43',
  'v3_breaker_gallery_primary_left_arrow_bg_color': '#FFE4E5',
  'v3_breaker_gallery_primary_left_arrow_color': '#9CA0B0',
  'v3_breaker_gallery_primary_mobile_arrow_color': '#0C0E1C',
  'v3_breaker_gallery_primary_paging_image_underline_color': '#E61E43',
  'v3_breaker_gallery_primary_right_arrow_bg_color': '#E61E43',
  'v3_breaker_gallery_primary_right_arrow_color': '#FFFFFF',
  'v3_breaker_gallery_secondary_background_color': '#FFFFFF',
  'v3_breaker_gallery_secondary_body_copy_color': '#676A7D',
  'v3_breaker_gallery_secondary_body_copy_icon_color': '#E61E43',
  'v3_breaker_gallery_secondary_left_arrow_bg_color': '#FFE4E5',
  'v3_breaker_gallery_secondary_left_arrow_color': '#9CA0B0',
  'v3_breaker_gallery_secondary_mobile_arrow_color': '#0C0E1C',
  'v3_breaker_gallery_secondary_paging_image_underline_color': '#E61E43',
  'v3_breaker_gallery_secondary_right_arrow_bg_color': '#E61E43',
  'v3_breaker_gallery_secondary_right_arrow_color': '#FFFFFF',
  'v3_breaker_gallery_tertiary_background_color': '#E61E43 ',
  'v3_breaker_gallery_tertiary_body_copy_color': '#FFFFFF',
  'v3_breaker_gallery_tertiary_body_copy_icon_color': '#FFFFFF',
  'v3_breaker_gallery_tertiary_left_arrow_bg_color': '#FFE4E5',
  'v3_breaker_gallery_tertiary_left_arrow_color': '#9CA0B0 ',
  'v3_breaker_gallery_tertiary_mobile_arrow_color': '#FFFFFF',
  'v3_breaker_gallery_tertiary_paging_image_underline_color': '#FBF8F1',
  'v3_breaker_gallery_tertiary_right_arrow_bg_color': '#E61E43',
  'v3_breaker_gallery_tertiary_right_arrow_color ': '#FFFFFF',
  'v3_breaker_image_batch2_border_radius': '8px',
  'v3_breaker_image_batch2_primary_background_color': '#FBF8F1',
  'v3_breaker_image_batch2_primary_caption_color': '#676A7D',
  'v3_breaker_image_batch2_primary_caption_ico_color': '#E61E43',
  'v3_breaker_image_batch2_secondary_background_color': '#FFFFFF',
  'v3_breaker_image_batch2_secondary_caption_color': '#676A7D',
  'v3_breaker_image_batch2_secondary_caption_ico_color': '#E61E43',
  'v3_breaker_image_batch2_tertiary_background_color': '#E61E43',
  'v3_breaker_image_batch2_tertiary_caption_color': '#FFFFFF',
  'v3_breaker_image_batch2_tertiary_caption_ico_color': '#FFFFFF',
  'v3_breaker_promo_cta_bg_color': '#FFFFFF',
  'v3_breaker_promo_cta_text_color': '#0C0E1C',
  'v3_breaker_promo_play_btn_color': '#FDDB32',
  'v3_breaker_promo_simplified_bg_color': '#191E3B',
  'v3_breaker_promo_sub_title_color': '#FFFFFF',
  'v3_breaker_promo_terms_text_color': '#FFFFFF',
  'v3_breaker_promo_title_color': '#FFFFFF',
  'v3_card_cta_color': sharedToken.color.common.cpds_neutral_900,
  'v3_card_location_color': sharedToken.color.common.cpds_neutral_500,
  'v3_card_location_icon_color': sharedToken.color.common.cpds_red_500,
  'v3_card_pagination_color': sharedToken.color.common.cpds_neutral_900,
  'v3_card_title_color': sharedToken.color.common.cpds_neutral_900,
  'v3_cpds_video_border_radius': '8px',
  'v3_discover_more_module_cta_bg_color': sharedToken.color.common.cpds_neutral_0,
  'v3_discover_more_module_cta_text_color': sharedToken.color.common.cpds_neutral_800,
  'v3_discover_more_module_desktop_height': '587px',
  'v3_discover_more_module_mobile_height': '600px',
  'v3_discover_more_module_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_editorial_feature1_up_primary_bg_color': '#FBF8F1',
  'v3_editorial_feature1_up_primary_date_text_color': '#676A7D',
  'v3_editorial_feature1_up_primary_desc_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_primary_link_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_primary_padding_around': 'true',
  'v3_editorial_feature1_up_primary_sponsored_text_color': '#676A7D',
  'v3_editorial_feature1_up_primary_tag_border_color': '#F37A8A',
  'v3_editorial_feature1_up_primary_tag_text_color': '#4D5167',
  'v3_editorial_feature1_up_primary_title_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_secondary_bg_color': '#FFFFFF',
  'v3_editorial_feature1_up_secondary_date_text_color': '#676A7D',
  'v3_editorial_feature1_up_secondary_desc_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_secondary_link_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_secondary_padding_around': 'true',
  'v3_editorial_feature1_up_secondary_sponsored_text_color': '#676A7D',
  'v3_editorial_feature1_up_secondary_tag_border_color': '#F37A8A',
  'v3_editorial_feature1_up_secondary_tag_text_color': '#4D5167',
  'v3_editorial_feature1_up_secondary_title_text_color': '#0C0E1C',
  'v3_editorial_feature1_up_tertiary_bg_color': '#E61E43',
  'v3_editorial_feature1_up_tertiary_date_text_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_desc_text_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_link_text_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_padding_around': 'true',
  'v3_editorial_feature1_up_tertiary_sponsored_text_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_tag_border_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_tag_text_color': '#FFFFFF',
  'v3_editorial_feature1_up_tertiary_title_text_color': '#FFFFFF',
  'v3_editorial_feature1_upborder_border_radius': '8px',
  'v3_feature_1up_w2_ImageContainerHeight': 'auto',
  'v3_feature_1up_w2_ImageContainerPosition': 'relative',
  'v3_feature_1up_w2_ImageOneAspectRatio_d': '4/3',
  'v3_feature_1up_w2_ImageOneAspectRatio_m': '1/1',
  'v3_feature_1up_w2_ImageOneMarginLeft_d': '0',
  'v3_feature_1up_w2_ImageOneMarginLeft_m': '0',
  'v3_feature_1up_w2_ImageOneMarginLeft_t': '0',
  'v3_feature_1up_w2_ImageTwoAspectRatio_d': '1/1',
  'v3_feature_1up_w2_ImageTwoAspectRatio_m': '1/1',
  'v3_feature_1up_w2_ImageTwoBottom': '0',
  'v3_feature_1up_w2_ImageTwoMaxWidth_d': '416px',
  'v3_feature_1up_w2_ImageTwoMaxWidth_m': 'auto',
  'v3_feature_1up_w2_ImageTwoMaxWidth_t': 'auto',
  'v3_feature_1up_w2_ImageTwoPosition': 'relative',
  'v3_feature_1up_w2_bodyContainerPaddingTop': '16px',
  'v3_feature_1up_w2_cta_top_margin': '0px',
  'v3_feature_1up_w2_description_mobile_padding': '0px',
  'v3_feature_1up_w2_description_padding': '0px',
  'v3_feature_1up_w2_hedding_padding': '0px',
  'v3_feature_1up_w2_image_primary_background_color': sharedToken.color.common.cpds_cream_100,
  'v3_feature_1up_w2_image_secondary_background_color': sharedToken.color.common.cpds_neutral_0,
  'v3_feature_1up_w2_image_tertiary_background_color': sharedToken.color.common.cpds_red_500,
  'v3_feature_1up_w2_mainWrapperFlexDirection': 'column',
  'v3_feature_1up_w2_mainWrapperGap': '56px',
  'v3_feature_1up_w2_primary_body_copy_color': '#4D5167',
  'v3_feature_1up_w2_primary_body_ctaText_color': sharedToken.color.common.cpds_neutral_900,
  'v3_feature_1up_w2_primary_heading_color': sharedToken.color.common.cpds_neutral_900,
  'v3_feature_1up_w2_primary_tag_color': '#4D5167',
  'v3_feature_1up_w2_secondary_body_copy_color': '#4D5167',
  'v3_feature_1up_w2_secondary_body_ctaText_color': sharedToken.color.common.cpds_neutral_900,
  'v3_feature_1up_w2_secondary_heading_color': sharedToken.color.common.cpds_neutral_900,
  'v3_feature_1up_w2_secondary_tag_color': '#4D5167',
  'v3_feature_1up_w2_tertiary_body_copy_color': sharedToken.color.common.cpds_neutral_0,
  'v3_feature_1up_w2_tertiary_body_ctaText_color': sharedToken.color.common.cpds_neutral_0,
  'v3_feature_1up_w2_tertiary_heading_color': sharedToken.color.common.cpds_neutral_0,
  'v3_feature_1up_w2_tertiary_tag_color': sharedToken.color.common.cpds_neutral_0,
  'v3_feature_1up_w2_textContainerFlexDirection': 'row',
  'v3_feature_1up_w2_textContainerGap': '154px',
  'v3_feature_1up_w2_textContainerMaxWidth': 'unset',
  'v3_feature_1up_w2_textContainerWidth': 'auto',
  'v3_feature_1up_w2_titleContainerGap': '16px',
  'v3_feature_1up_w2_titleWrapperMaxWidth': 'unset',
  'v3_hotel_deals_card_primary_text_color': sharedToken.color.common.cpds_neutral_800,
  'v3_hotel_deals_card_secondary_text_color': sharedToken.color.common.cpds_neutral_500,
  'v3_image_hero_scroll_down_arrow_color': sharedToken.color.common.cpds_neutral_0,
  'v3_image_hero_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_inline_accordian_description_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_image_border_radius': '8px',
  'v3_inline_accordian_item_heading_border_color': sharedToken.color.common.cpds_cream_400,
  'v3_inline_accordian_primary_accordian_heading_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_primary_bg_color': sharedToken.color.common.cpds_neutral_0,
  'v3_inline_accordian_primary_card_color': 'LIGHT',
  'v3_inline_accordian_primary_heading_icon_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_primary_headline_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_secondary_card_color': 'DARK',
  'v3_inline_accordian_secondary_heading_icon_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_secondary_headline_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accordian_see_more_cta_color': sharedToken.color.common.cpds_neutral_900,
  'v3_inline_accrodian_secondary_bg_color': sharedToken.color.common.cpds_neutral_0,
  'v3_inline_video_border_radius': '8px',
  'v3_inline_video_primary_background_color': '#FBF8F1',
  'v3_inline_video_primary_body_copy_color': '#31374F',
  'v3_inline_video_primary_play_button_arrow_color': '#0C0E1C',
  'v3_inline_video_primary_play_button_color': '#FFFFFF',
  'v3_inline_video_primary_timestamp_color': '#31374F',
  'v3_inline_video_primary_timestamp_text_active_color': '#676A7D',
  'v3_inline_video_primary_timestamp_text_color': '#31374F',
  'v3_inline_video_primary_title_color': '#0C0E1C',
  'v3_inline_video_primary_transcript_color': '#0C0E1C',
  'v3_inline_video_secondary_background_color': '#FFFFFF',
  'v3_inline_video_secondary_body_copy_color': '#31374F',
  'v3_inline_video_secondary_play_button_arrow_color': '#0C0E1C',
  'v3_inline_video_secondary_play_button_color': '#FFFFFF',
  'v3_inline_video_secondary_timestamp_color': '#31374F',
  'v3_inline_video_secondary_timestamp_text_active_color': '#676A7D',
  'v3_inline_video_secondary_timestamp_text_color': '#31374F',
  'v3_inline_video_secondary_title_color': '#0C0E1C',
  'v3_inline_video_secondary_transcript_color': '#0C0E1C',
  'v3_inline_video_tertiary_background_color': '#FFFFFF',
  'v3_inline_video_tertiary_body_copy_color': '#31374F',
  'v3_inline_video_tertiary_play_button_arrow_color': '#0C0E1C',
  'v3_inline_video_tertiary_play_button_color': '#FFFFFF',
  'v3_inline_video_tertiary_timestamp_color': '#31374F',
  'v3_inline_video_tertiary_timestamp_text_active_color': '#676A7D',
  'v3_inline_video_tertiary_timestamp_text_color': '#31374F',
  'v3_inline_video_tertiary_title_color': '#0C0E1C',
  'v3_inline_video_tertiary_transcript_color': '#0C0E1C',
  'v3_lists_border_radius': '8px',
  'v3_lists_primary_bg_color': '#FBF8F1',
  'v3_lists_primary_border_color': '#EBE4D5',
  'v3_lists_primary_desc_text_color': '#0C0E1C',
  'v3_lists_primary_icon_color': '#E61E43',
  'v3_lists_primary_list_bulleted_desc_color': '#0C0E1C',
  'v3_lists_primary_list_bulleted_title_color': '#0C0E1C',
  'v3_lists_primary_number_text_color': '#E61E43',
  'v3_lists_primary_stats_mod_border_color': '#C01E1E',
  'v3_lists_primary_stats_mod_copy_text_color': '#4D5167',
  'v3_lists_primary_stats_mod_headline_text_color': '#0C0E1C',
  'v3_lists_primary_stats_mod_icons_mobile_border_color': '#EBE4D5',
  'v3_lists_primary_stats_mod_list_desc_text_color': '#0C0E1C',
  'v3_lists_primary_stats_mod_list_title_text_color': '#0C0E1C',
  'v3_lists_primary_stats_mod_presentage_text_color': '#0C0E1C',
  'v3_lists_primary_title_text_color': '#0C0E1C',
  'v3_lists_secondary_bg_color': '#FFFFFF',
  'v3_lists_secondary_border_color': '#EBE4D5',
  'v3_lists_secondary_desc_text_color': '#0C0E1C',
  'v3_lists_secondary_icon_color': '#E61E43',
  'v3_lists_secondary_list_bulleted_desc_color': '#0C0E1C',
  'v3_lists_secondary_list_bulleted_title_color': '#0C0E1C',
  'v3_lists_secondary_number_text_color': '#E61E43',
  'v3_lists_secondary_stats_mod_border_color': '#C01E1E',
  'v3_lists_secondary_stats_mod_copy_text_color': '#4D5167',
  'v3_lists_secondary_stats_mod_headline_text_color': '#0C0E1C',
  'v3_lists_secondary_stats_mod_icons_mobile_border_color': '#EBE4D5',
  'v3_lists_secondary_stats_mod_list_desc_text_color': '#0C0E1C',
  'v3_lists_secondary_stats_mod_list_title_text_color': '#0C0E1C',
  'v3_lists_secondary_stats_mod_presentage_text_color': '#0C0E1C',
  'v3_lists_secondary_title_text_color': '#0C0E1C',
  'v3_lists_tertiary_bg_color': '#FFFFFF',
  'v3_lists_tertiary_border_color': '#EBE4D5',
  'v3_lists_tertiary_desc_text_color': '#0C0E1C',
  'v3_lists_tertiary_icon_color': '#E61E43',
  'v3_lists_tertiary_list_bulleted_desc_color': '#0C0E1C',
  'v3_lists_tertiary_list_bulleted_title_color': '#0C0E1C',
  'v3_lists_tertiary_number_text_color': '#E61E43',
  'v3_lists_tertiary_stats_mod_border_color': '#C01E1E',
  'v3_lists_tertiary_stats_mod_copy_text_color': '#4D5167',
  'v3_lists_tertiary_stats_mod_headline_text_color': '#0C0E1C',
  'v3_lists_tertiary_stats_mod_icons_mobile_border_color': '#EBE4D5',
  'v3_lists_tertiary_stats_mod_list_desc_text_color': '#0C0E1C',
  'v3_lists_tertiary_stats_mod_list_title_text_color': '#0C0E1C',
  'v3_lists_tertiary_stats_mod_presentage_text_color': '#0C0E1C',
  'v3_lists_tertiary_title_text_color': '#0C0E1C',
  'v3_live_event_hero_cta_color_default': sharedToken.color.common.cpds_neutral_900,
  'v3_live_event_hero_cta_color_tertiary': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_description_text_color_default': sharedToken.color.common.cpds_neutral_600,
  'v3_live_event_hero_description_text_color_tertiary': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_event_detail_seperator_color_default': sharedToken.color.common.cpds_neutral_200,
  'v3_live_event_hero_event_detail_seperator_color_tertiary': sharedToken.color.common.cpds_cream_400,
  'v3_live_event_hero_event_icon_color_default': sharedToken.color.common.cpds_red_500,
  'v3_live_event_hero_event_icon_color_tertiary': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_headline_text_color_default': sharedToken.color.common.cpds_neutral_900,
  'v3_live_event_hero_headline_text_color_tertiary': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_image_border_radius': '8px',
  'v3_live_event_hero_image_panel_bottom_padding': '0px',
  'v3_live_event_hero_image_panel_padding': '16px',
  'v3_live_event_hero_location_icon': 'pin-filled',
  'v3_live_event_hero_meta_text_color_default': sharedToken.color.common.cpds_neutral_500,
  'v3_live_event_hero_meta_text_color_tertiary': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_primary_bgcolor': sharedToken.color.common.cpds_cream_100,
  'v3_live_event_hero_secondary_bgcolor': sharedToken.color.common.cpds_neutral_0,
  'v3_live_event_hero_tag_color_default': 'dark',
  'v3_live_event_hero_tag_color_tertiary': 'light',
  'v3_live_event_hero_tertiary_bgcolor': sharedToken.color.common.cpds_red_500,
  'v3_live_event_hero_top_image_variation_height': '808px',
  'v3_live_event_hero_video_icon_color': sharedToken.color.common.cpds_neutral_0,
  'v3_media_gallery_background_color': sharedToken.color.common.cpds_neutral_0,
  'v3_media_gallery_cta_color': sharedToken.color.common.cpds_neutral_800,
  'v3_media_gallery_headline_color': sharedToken.color.common.cpds_neutral_800,
  'v3_media_gallery_item_text_color': sharedToken.color.common.cpds_neutral_800,
  'v3_media_gallery_nav_arrow_bg_color': sharedToken.color.common.cpds_accent_600,
  'v3_media_gallery_nav_color': sharedToken.color.secondary_0,
  'v3_media_gallery_progress_bar_bg_color': sharedToken.color.common.cpds_neutral_800,
  'v3_media_gallery_slider_pagination_text_color': sharedToken.color.common.cpds_neutral_800,
  'v3_parent_grid_max_width': '1680px',
  'v3_product_card_price_text_color': sharedToken.color.common.cpds_neutral_900,
  'v3_sub_brand_banner_primary_bg_color': '#FBF8F1',
  'v3_sub_brand_banner_secondary_bg_color': '#FBF8F1',
  'v3_sub_brand_banner_tertiary_bg_color': '#FBF8F1',
  'v3_tabbed_deals_load_more_cta_color': sharedToken.color.common.cpds_neutral_800,
  'v3_tabbed_deals_module_bg_color': sharedToken.color.common.cpds_neutral_0,
  'v3_tabbed_deals_module_headline_color': sharedToken.color.common.cpds_neutral_800,
  'v3_tabbed_deals_module_progress_bar_bg_color': sharedToken.color.common.cpds_accent_500,
  'v3_tabbed_deals_module_summery_color': sharedToken.color.common.cpds_neutral_500,
  'v3_tabbed_deals_slider_pagination_text_color': sharedToken.color.common.cpds_neutral_800,
  'v3_tabbed_deals_view_more_cta_bg_color': sharedToken.color.common.cpds_accent_600,
  'v3_tabbed_deals_view_more_cta_hover_bg_color': sharedToken.color.common.cpds_accent_700,
  'v3_tabbed_deals_view_more_cta_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_episode_label_bg_color': sharedToken.color.common.cpds_neutral_700,
  'v3_video_hero_episode_label_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_episode_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_episode_title_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_scroll_down_arrow_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_text_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_thumbnail_controls_color': sharedToken.color.common.cpds_neutral_0,
  'v3_video_hero_volum_controll_icon_color': sharedToken.color.common.cpds_neutral_0,
  'video_play_button_dark_primary_default_arrow_color': '#FFFFFF',
  'video_play_button_dark_primary_default_border_color': '#FFFFFF',
  'video_play_button_dark_primary_disabled_arrow_color': '#F37A8A',
  'video_play_button_dark_primary_disabled_border_color': '#F37A8A',
  'video_play_button_dark_primary_focus_arrow_color': '#FFFFFF',
  'video_play_button_dark_primary_focus_border_color': '#FFFFFF',
  'video_play_button_dark_primary_focus_outer_border_color': '#FFE4E5',
  'video_play_button_dark_primary_hover_arrow_color': '#0C0E1C',
  'video_play_button_dark_primary_hover_border_color': '#FFFFFF',
  'video_play_button_dark_secondary_default_arrow_color': '#FFFFFF',
  'video_play_button_dark_secondary_default_border_color': '#FFFFFF',
  'video_play_button_dark_secondary_disabled_arrow_color': '#F37A8A',
  'video_play_button_dark_secondary_disabled_border_color': '#F37A8A',
  'video_play_button_dark_secondary_focus_arrow_color': '#FFFFFF',
  'video_play_button_dark_secondary_focus_border_color': '#FFFFFF',
  'video_play_button_dark_secondary_focus_outer_border_color': '#FFE4E5',
  'video_play_button_dark_secondary_hover_arrow_color': '#0C0E1C',
  'video_play_button_dark_secondary_hover_border_color': '#FFFFFF',
  'video_play_button_light_default_arrow_color': '#E61E43',
  'video_play_button_light_default_border_color': '#E61E43',
  'video_play_button_light_disabled_arrow_color': '#9CA0B0',
  'video_play_button_light_disabled_border_color': '#F0EBDF',
  'video_play_button_light_focus_arrow_color': '#E61E43',
  'video_play_button_light_focus_border_color': '#E61E43',
  'video_play_button_light_focus_outer_border_color': '#191E3B',
  'video_play_button_light_hover_arrow_color': '#FFFFFF',
  'video_play_button_light_hover_border_color': '#E61E43',
  ...sharedToken
};